import React, { useEffect, useState } from "react";
import epicBgimg from "./../../assets/images/epic-login-bg.png";
import epicLogo from "./../../assets/images/epic-product-logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { ENDPOINTS } from "../../js/api/_config";
import axios from "axios";
import CustomCheckbox from "./custom-checkbox";
import { Toast } from "../common/toast/toast";
import Banner from "./banner";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState("");
  const [toasts, setToasts] = useState([]);
  const navigate = useNavigate();

  // On mount, check if a remembered email exists
  useEffect(() => {
     const savedUsername = localStorage.getItem("rememberedUsername");
     const savedPassword = localStorage.getItem("rememberedPassword");
     if (savedUsername) {
       setUsername(savedUsername);
       setRememberMe(true);
     }
   
   }, []);

  const validateFields = () => {
    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username)) {
      newErrors.username = "Invalid email format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    const email = encodeURIComponent(username);
    if (!validateFields()) return;

    try {
      const response = await axios.get(`${ENDPOINTS.PASSWORD.FORGOT_PASSWORD}/${email}`);

      // Handle success
      setMessage(response.data.data || "Password reset link sent to your email.");
      addToast(response.data.data || "Password reset link sent to your email.", 'success')
      // Remember the email if "Remember Me" is checked
      if (rememberMe) {
        localStorage.setItem("rememberedUsername", username);
        // localStorage.setItem("rememberedPassword", password);
      } else {
        localStorage.removeItem("rememberedUsername");
        // localStorage.removeItem("rememberedPassword");
      }
    } catch (err) {
      // Handle error
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
      addToast(err.response?.data?.message || "Something went wrong. Please try again.", "error")
    }
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000); // Auto-dismiss after 3 seconds
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Left Side - Carousel */}
      <Banner />
      {toasts.map((toast) => (
              <Toast
                key={toast.id}
                toast={toast}
                onClose={() => removeToast(toast.id)}
              />
            ))}

      {/* Right Side - Forgot Password Form */}
      <div className="w-2/3 bg-white flex flex-col justify-center items-center px-8 relative">
        <div className="w-full max-w-[420px]">
        <img src={epicLogo} alt="Logo" className="mb-[60px] mx-auto w-[278px]" />
        <h2 className="text-[32px] font-[600] text-center font-mont mb-[40px]">Forgot Password ?</h2>
          {/* <p className="mb-6 font-mont">No worries, we'll send you reset instructions</p> */}

          <form className="space-y-4" onSubmit={(e) => handleForgotPassword(e)}>
          <div>
              <label htmlFor="password" className="block text-sm text-gray-700 text-[16px] font-[600] mb-3">
              Email
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
                  {errors.username && <span className="text-[#F95454] font-mont text-[14px] font-[500]">{errors.username}</span>}
            </div>
           

            <div className="flex items-center justify-between">
            {/* <CustomCheckbox isChecked={rememberMe} setIsChecked={setRememberMe} /> */}
            </div>

            <button
              type="submit"
               className="w-full bg-[#245CEA] text-[#FFFFFF] py-2 rounded hover:bg-blue-600 font-mont font-[600] text-[18px]"
            >
              Reset Password
            </button>
            <Link
              to="/login"
              className="flex text-xs text-black-100 text-center items-center justify-center w-full mt-4 text-[14px] font-mont font-[500]"
            >

              <div className="h-[14px] mb-1 mr-3"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 9H4" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 14.25L3.75 9L9 3.75" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg></div>
              Back to Login
            </Link>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
        </div>
        <p className="text-center text-sm text-gray-500 absolute bottom-3">
          &copy; 2025 eClinRecruit. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
